import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { MePlan } from '../types/domain';

export function mePlanEndpoints(http: HttpClient) {
  return {
    get: () => http.get<ApiEnvelope<MePlan>>('/v1/me/plan').then(unwrap),
    requestUpgrade: (note?: string) => http.post<ApiEnvelope<Record<string, unknown>>>('/v1/me/upgrade-request', { note }).then(unwrap),
  };
}
export type MePlanEndpoints = ReturnType<typeof mePlanEndpoints>;
